module.exports = "https://static.wmbcdn.com/uniweb/images/0fe9531d49e265241850ecbdb232ddfe.svg";